import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VersionComponent } from './version.component';


@NgModule({
  declarations: [
    VersionComponent
  ],
  imports: [
    CommonModule,MatIconModule, MatTooltipModule
  ],  
  exports: [VersionComponent]
})
export class VersionModule { }
